<template>
  <div>
    <v-data-table
      :headers="headers"
      :items="admin_emails"
      :items-per-page="-1"
      class="smoke"
      hide-default-footer
      :search="search"
      height="90vh"
      hide-default-header
      :loading="loading.admin.emails"
    >
      <template v-slot:top>
        <div>
          <div class="pa-4 d-flex align-center" style="gap: 10px">
            <v-text-field
              v-model="search"
              label="Search"
              variant="solo"
              flat
              style="border-radius: 6px"
              hide-details=""
            ></v-text-field>
            <v-btn
              height="48"
              :loading="loading.admin.emails"
              elevation="0"
              color="primary"
              @click="$store.dispatch('fetchAdminEmails')"
              ><v-icon color="white">mdi-refresh</v-icon></v-btn
            >
          </div>
          <v-divider></v-divider>
        </div>
      </template>

      <template v-slot:[`item.delivery.startTime`]="{ item }">
        <span v-if="item.delivery?.startTime">
          {{ formatDate(item.delivery?.startTime) }}
        </span>
        <span v-else> - </span>
      </template>

      <template v-slot:[`item.to`]="{ item }">
        <span>{{ item.to }}</span>
        <span>{{ item.bcc }}</span>
      </template>

      <template v-slot:[`item.actions`]="{ item }">
        <v-menu>
          <template v-slot:activator="{ props }">
            <v-btn
              v-bind="props"
              icon="mdi-dots-horizontal"
              size="small"
              variant="text"
            ></v-btn>
          </template>
          <v-list>
            <v-list-item @click="openInFb(item.uid)">
              <v-list-item-title>
                <v-icon start size="small">mdi-firebase</v-icon>
                Open in Firebase
              </v-list-item-title>
            </v-list-item>
            <v-list-item
              v-if="item.template?.html"
              @click="viewEmailHtml(item.template.html)"
            >
              <v-list-item-title>
                <v-icon start size="small">mdi-eye</v-icon>
                View
              </v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
      </template>
    </v-data-table>
  </div>
</template>

<style lang="scss" scoped></style>

<script>
import { mapState } from "vuex";
import moment from "moment";

export default {
  computed: {
    ...mapState({
      userProfile: (state) => state.users.userProfile,
      loading: (state) => state.loading,
      admin_emails: (state) => state.admin.emails,
    }),
  },
  data() {
    return {
      search: "",
      headers: [
        { text: "To", value: "to" },
        { text: "Template", value: "template.name" },
        { text: "Date", value: "delivery.startTime" },
        { text: "Status", value: "delivery.state" },
        { text: "", value: "actions" },
      ],
      filter_noposts: false,
    };
  },
  methods: {
    formatDate(d) {
      let date = d.toDate();
      return moment(date).format("DD-MM-YYYY - hh:mm");
    },
    openInFb(uid) {
      let production = window.location.origin.includes("app.stix.social");
      let url = `https://console.firebase.google.com/u/0/project/${
        production ? "stix-production" : "stix-staging-f240f"
      }/firestore/data/~2Fmail~2F${uid}`;
      window.open(url, "_blank");
    },
    viewEmailHtml(htmlContent) {
      if (!htmlContent) {
        console.warn("No HTML content to display");
        return;
      }

      const blob = new Blob([htmlContent], { type: "text/html" });
      const url = URL.createObjectURL(blob);
      window.open(url, "_blank");

      // Clean up the URL object after opening
      setTimeout(() => URL.revokeObjectURL(url), 1000);
    },
  },
};
</script>
